import BaseStore from '@src/utils/store/base-store';

class PageStore extends BaseStore {
  use() {
    super.use();
  }
}

export default PageStore;
